// Configurations
import APIConfig from '@/config/api'

// Helpers
import probeAPIEndpoint from '@/helpers/api/probe-endpoint'

export async function fetchCheckOnline(): Promise<boolean> {
	return probeAPIEndpoint({ apiUrl: APIConfig.url })
}
